import React from "react"

const InfoText = () => {
  return (
    <>
      <div data-aos="fade-down" className="col-lg-6 ml-auto info-container">
        Tworzeniem stron internetowych zajmuje się od dwóch lat. Zaczynałem
        tworząc motywy pod CMS wordpress. W ten sposób wykonywałem różne
        zlecenia, ucząc się przy okazji Bootstrap'a, języka PHP oraz HTML. Od
        stycznia tego roku rozpocząłem nauke biblioteki React. Wykonując kolejne
        zlecenia pogłębiałem dalszą wiedzę front-end ucząc się NextJS, Gatsby
        oraz GraphQL. Od czerwca pracuje przy komercyjnych projektach w firmie
        KMB Studio, wykorzystując framework Gatsby. Aktualnie piszę pracę
        dyplomową, której tematem jest aplikacja mobilna w technologii React
        Native. Postęp prac można obejrzeć na moim githubie (repozytorium
        firstReactNativeApp). Szukam pracy na stanowisku web-developera w
        okolicach Rzeszowa lub zdalnie. Nie boję się żadnych wyzwań i chętnie
        podejmę naukę technologii, której jeszcze nie znam.
      </div>
    </>
  )
}

export default InfoText
